/* product-system.js — PDP interactions (Matcha PDP и далее).
   Модули регистрируются через data-атрибуты, инициализация идемпотентная:
   повторный вызов init() (Theme Editor section reload) не дублирует обработчики. */

(function () {
  'use strict';

  var INIT_FLAG = 'productSystemInit';

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = String(Math.round(cents / 100));
    if (amount.slice(-3) === '.00') amount = noDecimals;
    return (format || '{{ amount }} ₪')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  function getSectionEl(sectionId) {
    return document.querySelector('[data-section="' + sectionId + '"]');
  }

  function getVariantData(sectionId) {
    var picker =
      document.querySelector('variant-radios[data-section="' + sectionId + '"]') ||
      document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    if (!picker) return null;
    var json = picker.querySelector('[type="application/json"]');
    if (!json) return null;
    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Shopify рендерит подпись dynamic checkout после Liquid и может пересоздать
     кнопку при смене варианта. Держим локализованный DS-label синхронным. */
  function initQuickBuyLabel(root) {
    root.querySelectorAll('[data-product-quick-buy]').forEach(function (form) {
      if (form.dataset[INIT_FLAG + 'QuickBuyLabel']) return;
      form.dataset[INIT_FLAG + 'QuickBuyLabel'] = 'true';

      var label = form.dataset.quickBuyLabel;
      if (!label) return;

      function updateLabel() {
        var button = form.querySelector('.shopify-payment-button__button--unbranded');
        if (!button) return;
        if (button.textContent.trim() !== label) button.textContent = label;
        button.setAttribute('aria-label', label);
      }

      var observer = new MutationObserver(updateLabel);
      observer.observe(form, { childList: true, subtree: true });
      updateLabel();

      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(form)) observer.disconnect();
      });
    });
  }

  /* Sticky ATC: показать бар, когда buy-row полностью ушёл за верх экрана. */
  function initStickyAtc(root) {
    var bar = root.querySelector('[data-product-sticky-atc]');
    if (!bar || bar.dataset[INIT_FLAG]) return;
    bar.dataset[INIT_FLAG] = 'true';

    var sectionEl = bar.closest('[data-section]') || document;
    var buyRow = sectionEl.querySelector('[data-product-buy-row]');

    if (buyRow && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var gone = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          bar.hidden = !gone;
        },
        { threshold: 0 }
      );
      observer.observe(buyRow);
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(buyRow)) observer.disconnect();
      });
    }

    /* Степпер-прокси: правит основной Quantity-инпут формы и показывает его значение. */
    var sectionId = bar.dataset.sectionId;
    var qtyInput = document.getElementById('Quantity-' + sectionId);
    var qtyValue = bar.querySelector('[data-sticky-qty-value]');
    var quantityWrap = bar.querySelector('[data-sticky-quantity]');

    function syncQty() {
      if (qtyInput && qtyValue) qtyValue.textContent = qtyInput.value;
    }

    if (qtyInput && quantityWrap) {
      bar.querySelectorAll('[data-sticky-qty-decrease], [data-sticky-qty-increase]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          var next = btn.hasAttribute('data-sticky-qty-increase') ? current + 1 : Math.max(1, current - 1);
          qtyInput.value = next;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          syncQty();
        });
      });
      qtyInput.addEventListener('change', syncQty);
      syncQty();
    } else if (quantityWrap) {
      quantityWrap.hidden = true;
    }
  }

  /* Синхронизация наличия/цены при смене варианта.
     Слушаем change на input[name="id"] формы add-to-cart — Dawn global.js
     диспатчит его в updateVariantInput() при каждой смене варианта. */
  function initVariantSync(root) {
    var stock = root.querySelector('[data-product-stock]');
    var bar = root.querySelector('[data-product-sticky-atc]');
    if (!stock && !bar) return;
    var marker = stock || bar;
    if (marker.dataset[INIT_FLAG + 'Sync']) return;
    marker.dataset[INIT_FLAG + 'Sync'] = 'true';

    var sectionEl = marker.closest('[data-section]');
    var sectionId = sectionEl ? sectionEl.dataset.section : null;
    if (!sectionId) return;

    var strings = window.variantStrings || {};

    function applyVariant(variant) {
      var available = !!(variant && variant.available);
      if (stock) {
        stock.classList.toggle('product-stock--out', !available);
        var label = stock.querySelector('[data-product-stock-label]');
        if (label) {
          var inStockText = stock.dataset.inStockText;
          var soldOutText = stock.dataset.soldOutText || strings.soldOut;
          if (available && inStockText) label.textContent = inStockText;
          if (!available && soldOutText) label.textContent = soldOutText;
        }
      }
      var priceVariant = sectionEl.querySelector('[data-product-price-variant]');
      if (priceVariant && variant) {
        priceVariant.textContent = variant.title.split('(')[0].trim();
      }
      if (bar) {
        var price = bar.querySelector('[data-sticky-price]');
        if (price && variant) {
          price.textContent = formatMoney(variant.price, bar.dataset.moneyFormat);
        }
        var variantLabels = bar.querySelectorAll('[data-sticky-variant-label]');
        if (variant) {
          variantLabels.forEach(function (variantLabel) {
            variantLabel.textContent = variant.title;
          });
        }
        var submit = bar.querySelector('[data-sticky-submit]');
        var submitLabel = bar.querySelector('[data-sticky-submit-label]');
        if (submit) {
          submit.disabled = !available;
          if (submitLabel) {
            submitLabel.textContent = available
              ? strings.addToCart || submitLabel.textContent
              : strings.soldOut || submitLabel.textContent;
          }
        }
      }
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('input[name="id"]')) return;
      var form = input.closest('form');
      /* form.id недоступен напрямую: его перекрывает контрол с name="id" */
      if (!form || form.getAttribute('id') !== 'product-form-' + sectionId) return;
      var variants = getVariantData(sectionId);
      if (!variants) return;
      var variant = variants.find(function (v) {
        return String(v.id) === String(input.value);
      });
      applyVariant(variant);
    });
  }

  /* DS-галерея: медиа 1:1, автопрокрутка каждые 5 с, точки на mobile,
     видео перезапускается с начала при каждом показе слайда. */
  function initDsGallery(root) {
    var gallery = root.querySelector('media-gallery[data-ds-gallery]');
    if (!gallery || gallery.dataset[INIT_FLAG + 'Gallery']) return;
    gallery.dataset[INIT_FLAG + 'Gallery'] = 'true';

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    /* hide_variants прячет фото «чужих» вариантов (CSS product__media-item--variant,
       видимым остаётся только первый). В ротацию берём только видимые слайды —
       иначе автопрокрутка утыкается в скрытый слайд и галерея «пропадает». */
    function getSlides() {
      var all = Array.prototype.slice.call(viewer.querySelectorAll('li[data-media-id]'));
      return all.filter(function (slide, i) {
        return i === 0 || !slide.classList.contains('product__media-item--variant');
      });
    }

    var slides = getSlides();
    if (!slides.length) return;

    var interval = parseInt(gallery.dataset.dsAutoplay, 10) || 5000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currentIdx = Math.max(0, slides.findIndex(function (s) {
      return s.classList.contains('is-active');
    }));
    var timer = null;
    var dots = [];

    function restartMedia(slide) {
      var deferred = slide.querySelector('.deferred-media');
      if (deferred && typeof deferred.loadContent === 'function') deferred.loadContent(false);
      setTimeout(function () {
        var video = slide.querySelector('video');
        if (video) {
          video.muted = true;
          video.controls = false;
          video.setAttribute('playsinline', '');
          try {
            video.currentTime = 0;
          } catch (e) {}
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
          return;
        }
        var iframe = slide.querySelector('iframe');
        /* внешнее видео (YouTube/Vimeo): пересоздаём src — старт с начала */
        if (iframe && iframe.src) iframe.src = iframe.src;
      }, 80);
    }

    function updateDots(index) {
      dots.forEach(function (d, i) {
        if (i === index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      currentIdx = index;
      gallery.setActiveMedia(slide.dataset.mediaId, false);
      restartMedia(slide);
      updateDots(index);
    }

    /* любое действие пользователя (точка, миниатюра, свайп) останавливает
       автопрокрутку насовсем — управление переходит к пользователю */
    var userStopped = false;
    function userStop() {
      userStopped = true;
      stop();
    }

    if (slides.length > 1) {
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'product-gallery__dots';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        dot.addEventListener('click', function () {
          userStop();
          goTo(i);
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
      gallery.appendChild(dotsWrap);
      updateDots(currentIdx);
    }

    /* клик по миниатюре: стоп автопрокрутки, видео — с начала */
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbnails) {
      thumbnails.addEventListener('click', function (event) {
        var item = event.target.closest('[data-target]');
        if (!item) return;
        userStop();
        slides = getSlides();
        var idx = slides.findIndex(function (s) {
          return s.dataset.mediaId === item.dataset.target;
        });
        if (idx < 0) return;
        currentIdx = idx;
        updateDots(idx);
        /* setActiveMedia вызовет Dawn сам (обработчик миниатюры) — нам
           остаётся перезапустить видео с начала */
        restartMedia(slides[idx]);
      });
    }

    /* ручной свайп на mobile: слайдер диспатчит slideChanged, но он же
       срабатывает при инициализации и нашей автопрокрутке — считаем событие
       пользовательским только после недавнего pointer/touch/wheel */
    var lastInteraction = 0;
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evName) {
      viewer.addEventListener(evName, function () {
        lastInteraction = Date.now();
      }, { passive: true });
    });

    viewer.addEventListener('slideChanged', function (event) {
      var el = event.detail && event.detail.currentElement;
      slides = getSlides();
      var idx = slides.indexOf(el);
      if (idx < 0 || idx === currentIdx) return;
      var isUser = Date.now() - lastInteraction < 1500;
      currentIdx = idx;
      updateDots(idx);
      restartMedia(slides[idx]);
      if (isUser) userStop();
    });

    function tick() {
      /* не листаем, пока открыт зум-модал */
      if (document.querySelector('.product-media-modal[open]')) return;
      slides = getSlides(); /* после смены варианта видимый набор меняется */
      goTo((currentIdx + 1) % slides.length);
    }

    function start() {
      if (userStopped || reduceMotion || slides.length < 2 || timer) return;
      timer = setInterval(tick, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(gallery)) stop();
    });

    /* если стартовый слайд — видео, запускаем его сразу */
    if (slides[currentIdx].querySelector('.deferred-media')) restartMedia(slides[currentIdx]);
    start();
  }

  /* Отдельная длинная секция описания: reversible spoiler из handoff.
     Короткий текст в buy-zone всегда показывается целиком. */
  function initProductDescription(root) {
    root.querySelectorAll('[data-product-description]').forEach(function (section) {
      if (section.dataset[INIT_FLAG + 'Description']) return;
      section.dataset[INIT_FLAG + 'Description'] = 'true';

      var content = section.querySelector('[data-product-description-content]');
      var toggle = section.querySelector('[data-product-description-toggle]');
      var label = section.querySelector('[data-product-description-toggle-label]');
      if (!content || !toggle) return;

      if (content.scrollHeight <= content.clientHeight + 4) {
        content.classList.remove('is-collapsed');
        toggle.hidden = true;
        return;
      }

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        content.classList.toggle('is-collapsed', expanded);
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (label) label.textContent = expanded ? toggle.dataset.moreLabel : toggle.dataset.lessLabel;
      });
    });
  }

  /* FAQ: native details/summary сохраняет доступность без JS. При открытии
     пункта закрываем соседние — как в handoff; повторная инициализация safe. */
  function initProductFaq(root) {
    root.querySelectorAll('[data-product-faq]').forEach(function (section) {
      if (section.dataset[INIT_FLAG + 'Faq']) return;
      section.dataset[INIT_FLAG + 'Faq'] = 'true';

      var items = Array.prototype.slice.call(section.querySelectorAll('[data-product-faq-item]'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* Quick view: bottom sheet / модалка товара.
     Триггер [data-quick-view-trigger="<id>"] открывает #QuickView-<id>;
     закрытие — бэкдроп, крестик, Escape, успешный submit формы. */
  function initQuickView(root) {
    root.querySelectorAll('[data-quick-view-trigger]').forEach(function (trigger) {
      if (trigger.dataset[INIT_FLAG + 'Qv']) return;

      /* Флаг ставим только когда диалог реально найден, и он общий с
         product-card-premium.js: на детальной загружены оба скрипта, и порядок
         их выполнения не задан. Разметка бывает двух видов — готовый диалог в
         DOM (set-composition) и <template> рядом с карточкой (product-card-
         states). Templates понимает только premium; раньше этот init успевал
         занять флаг первым и лупа в «С этим покупают» умирала молча. */
      var dialog = document.getElementById('QuickView-' + trigger.dataset.quickViewTrigger);
      if (!dialog) return;

      trigger.dataset[INIT_FLAG + 'Qv'] = 'true';

      /* Портал в body: у предков секции бывает transform (sticky/scroll-
         анимации темы), из-за чего position:fixed считается от них и
         бэкдроп обрезается. */
      if (dialog.parentElement !== document.body) document.body.appendChild(dialog);

      var panel = dialog.querySelector('.product-quick-view__panel');
      var backdrop = dialog.querySelector('.product-quick-view__backdrop');
      var drag = null;
      var closing = false;

      function isSheet() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      function hideDialog() {
        dialog.hidden = true;
        closing = false;
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(trigger);
        if (drag) drag.reset();
        if (backdrop) backdrop.style.opacity = '';
      }

      function close() {
        if (dialog.hidden || closing) return;
        if (!panel || !window.DSSheet) {
          hideDialog();
          return;
        }
        closing = true;
        window.DSSheet.flyOut(panel, hideDialog, {
          up: !isSheet(),
          backdrop: isSheet() ? backdrop : null,
        });
      }

      function open() {
        if (drag) drag.reset();
        if (backdrop) backdrop.style.opacity = '';
        closing = false;
        dialog.hidden = false;
        /* см. product-card-premium.js: lazy-кадр стартует только сейчас */
        if (window.DSPopupMedia) window.DSPopupMedia.track(dialog);
        document.body.classList.add('overflow-hidden');
        if (typeof trapFocus === 'function') trapFocus(dialog);
      }

      // Escape — на document: на самом диалоге он молчал, стоило фокусу уйти наружу
      if (window.DSSheet) {
        window.DSSheet.onEscape(function () {
          return !dialog.hidden;
        }, close);

        if (panel) {
          drag = window.DSSheet.dragToDismiss(panel, {
            isEnabled: function () {
              return isSheet() && !dialog.hidden && !closing;
            },
            onDismiss: close,
            onDrag: function (delta) {
              if (!backdrop) return;
              var progress = Math.min(1, Math.max(0, delta) / Math.max(panel.offsetHeight, 1));
              backdrop.style.opacity = String(1 - progress * 0.7);
            },
          });
        }
      }

      trigger.addEventListener('click', open);
      dialog.querySelectorAll('[data-quick-view-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      var form = dialog.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function () {
          /* product-form.js делает fetch и показывает cart-notification —
             закрываем шит, чтобы нотификация была видна */
          setTimeout(close, 400);
        });
      }
      document.addEventListener('shopify:section:unload', function (event) {
        /* диалог перенесён в body — при перезагрузке секции удаляем его,
           чтобы Theme Editor не плодил дубликаты */
        if (event.target.contains(trigger)) {
          close();
          dialog.remove();
        }
      });
    });
  }

  /* Shopify Product Recommendations подгружает разметку после пересечения
     viewport и заменяет innerHTML custom element. Наблюдатель повторно запускает
     quick-view init только внутри обновлённого блока; флаги на триггерах не дают
     дублировать обработчики. */
  function initRecommendationContent(root) {
    root.querySelectorAll('product-recommendations').forEach(function (recommendationsEl) {
      if (recommendationsEl.dataset[INIT_FLAG + 'Recommendations']) return;
      recommendationsEl.dataset[INIT_FLAG + 'Recommendations'] = 'true';

      var observer = new MutationObserver(function () {
        initQuickView(recommendationsEl);
      });
      observer.observe(recommendationsEl, { childList: true });

      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(recommendationsEl)) observer.disconnect();
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    initQuickBuyLabel(root);
    initStickyAtc(root);
    initVariantSync(root);
    initDsGallery(root);
    initProductDescription(root);
    initProductFaq(root);
    initQuickView(root);
    initRecommendationContent(root);
  }

  window.ProductSystem = window.ProductSystem || { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
